module.exports = __webpack_public_path__ + "static/media/user3.ff80b0a5.jpeg";